import { readContentItems } from "../../../apis/httpHelper";
import baseField from "../BaseField" 
export default {
    mixins :[baseField],
    data: function () {
        return {
            queryState: false,
            saveField: [],
            isShowField: false,
            contentDefinition: [],
            singleObjectFormDefinition: {},
            singleObjectOrginalDisplay: {},
            editState: false
        };
    },
    computed:{
        value: function () {
            return JSON.stringify(this.data[this.name]);
        },
    },
    created:function(){
        this.saveField = this.selfSetting.SaveField;
        this.isShowField = this.selfSetting.IsShowField;
    },
    methods:{
        relyValueFun:function(){
            let that = this;
            let singleOperatorFilter = this.computedRequestData();

            let fields = this.saveField;
            if(!this.saveField.includes(this.fieldValueSetting.QueryValue)){
                fields.push(this.fieldValueSetting.QueryValue);
            }

            if (singleOperatorFilter.filters.length > 0) {
                readContentItems(
                    this.fieldValueSetting.QueryContentType,
                    fields,
                    0,
                    1,
                    undefined,
                    singleOperatorFilter,
                    false
                ).then(x=>{
                    that.relyValueFunSuccess(x.Result);
                }).catch(x=>{
                    console.log(this.displayName + "-" +this.name + "配置异常");
                    console.log(x);
                });
            }
        },

        setValueBeforeHook: function (value) {
            value = value || {};
            this.saveField.forEach(x => {
                value[x] = value.hasOwnProperty(x) ? value[x]: null;
            });
            return value;
        }
    }
}